import { responseHandleService } from './ResponseHandleService';
import AuthenticationService from './AuthenticationService';
import axios from 'axios';

export const decisionService = {
  getAll,
  createOrUpdate,
  deleteDecision
};
const requestOptions = {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  }
};

function getAll(pageNumber) {
  let url = `${
    process.env.REACT_APP_API_URL}/api/council_decisions/?page[number]=${pageNumber ? pageNumber : 1}`;

  return fetch(url, requestOptions)
    .then(responseHandleService.handleResponse)
    .catch(error => console.log(error));
}
function createOrUpdate(newDecision) {
  const requestOptions = {
    method: newDecision.id ? 'PUT' : 'POST',
    headers: {
      Accept: 'application/json'
    },
    body: createBodyRequest(newDecision)
  };

  let authentication = new AuthenticationService();

  console.log(authentication.loggedIn());

  if (authentication.loggedIn()) {
    requestOptions.headers['Authorization'] =authentication.getToken();
  }

  const url = `${process.env.REACT_APP_API_URL}/api/council_decisions${
    newDecision.id ? `/${newDecision.id}` : ''
  }`;

  return fetch(url, requestOptions).then(responseHandleService.handleResponse);
}
function createBodyRequest(decision) {
  let formData = new FormData();

  formData.append('council_decision[title]', decision.title);
  formData.append('council_decision[date]', decision.date);
  formData.append('council_decision[number]', decision.number);
  const document = decision.document;

  if (document) {
    if (document.url) {
      formData.append(`council_decision[document]`, document.url);
    } else {
      formData.append(`council_decision[document]`, document, document.name);
    }
  }

  return formData;
}
function deleteDecision(decisionId) {
  const requestOptionsDelete = {
    headers: {
      Accept: 'application/json'
    }
  };
  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptionsDelete.headers['Authorization'] =this.authentication.getToken();
  }
  let url = `${process.env.REACT_APP_API_URL}/api/council_decisions/${decisionId}`;

  return axios.delete(url, requestOptionsDelete);
}
